import React, {useCallback, useContext, useEffect, useState} from "react";
import {PageLoader} from "../../../../components/index.jsx";
import {MarketplaceContext} from "../../../marketplaceContext.jsx";
import "../../marketplace-booking.css";
import {ProductBookingForm} from "../ProductBookingForm.jsx";
import {ProductBookingContext} from "../ProductBookingContext.jsx";
import {StringBuilder} from "../../../../AppUtils.js";
import {ProductPaymentSection} from "../ProductPaymentSection.jsx";
import {ProductBookingAsClientPriceSection} from "./consts.js";
import {MarketplaceOrderPreview} from "../../MarketplaceOrderPreview.jsx";
import {Button, Input} from "antd";
import {EditIcon} from "../../../../icons";

export const ProductBookingAsClient = ({}) => {
    const {product} = useContext(MarketplaceContext);
    const [isOpen, setIsOpen] = useState(false);
    const [newOrderName, setNewOrderName] = useState("");

    const {
        me,
        company,
        formValues,
        setFormValues,
        totalOrderPrice,
        onFinishClick,
        bookingLoading,
        bookingError,
        offeredPrice,
        coupon,
        couponDiscountAmount,
        setCouponCode,
        onCancelCoupon,
        deliveryPrice,
        loadingDeliveryPrice,
        upgradeOptionsPrice,
        tip
    } = useContext(ProductBookingContext);

    useEffect(() => {
        if (!newOrderName && product?.productName) {
            setNewOrderName(product.productName);
        }
    }, [product, newOrderName]);

    const onPriceSectionValueChange = useCallback(
        (key, value) => {
            if (isNaN(Number(value))) {
                return;
            }

            setFormValues(prevValues => ({
                ...prevValues,
                [key]: Number(value)
            }));
        },
        [setFormValues]
    );

    const onProductNameChange = useCallback(
        value => {
            setNewOrderName(value);
            setFormValues(prevValues => ({
                ...prevValues,
                orderName: value
            }));
        },
        [setFormValues]
    );

    return (
        <>
            {product ? (
                <>
                    <div className="booking-container" style={{direction: "rtl"}}>
                        <div className="booking-container-width">
                            <div className="edit-order-view-title-container">
                                <span>
                                    {new StringBuilder(`יצירת הזמנה`, " - ").append(product?.productName).toString()}
                                    <Button
                                        onClick={() => setIsOpen(prev => !prev)}
                                        className="wb-provider-edit-image-relative"
                                        icon={<EditIcon style={{stroke: "#1260d1"}} />}
                                    />
                                    {isOpen && (
                                        <div className="admin-upload-new-product-disabled-dates-range-picker">
                                            <Input
                                                className="admin-table-date-search-search-input"
                                                value={newOrderName}
                                                onChange={e => onProductNameChange(e.target.value)}
                                            />
                                        </div>
                                    )}
                                </span>
                                <span>{me?.email}</span>
                            </div>
                            <div className="booking-container-wrapper">
                                <div className="booking-container-content" style={{flexDirection: "row-reverse"}}>
                                    <MarketplaceOrderPreview
                                        me={me}
                                        company={company}
                                        onFinishClick={onFinishClick}
                                        bookingLoading={bookingLoading}
                                        canFinish={!bookingError}
                                        content={product}
                                        formValues={formValues}
                                        offeredPrice={offeredPrice}
                                        coupon={coupon}
                                        couponDiscountAmount={couponDiscountAmount}
                                        onCouponAdded={setCouponCode}
                                        onCancelCoupon={onCancelCoupon}
                                        deliveryPrice={deliveryPrice}
                                        loadingDeliveryPrice={loadingDeliveryPrice}
                                        upgradeOptionsPrice={upgradeOptionsPrice}
                                        companyDiscount={formValues.companyDiscount}
                                        tip={tip}
                                        bookingError={bookingError}
                                    />

                                    <div style={{width: "100%"}}>
                                        <ProductBookingForm adminMode={true} />

                                        <ProductPaymentSection
                                            formValues={formValues}
                                            onFieldChange={onPriceSectionValueChange}
                                            totalPrice={totalOrderPrice}
                                            priceSectionLines={ProductBookingAsClientPriceSection}
                                            shouldShowTotalPrice={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <PageLoader style={{top: "80px"}} />
            )}
        </>
    );
};
